import React from 'react';
import { useEffect, useState } from "react";
import { Grid, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import styles from "../index.module.css";
import {
    Table, TableHead, TableBody, TableRow, TableCell
} from "@mui/material";

const AgenciesTable = ({ agencies = [], handleEdit, message }) => {
    return (
        <Grid item xs={12} md={12} className="agencies-table">
            <Paper sx={{ overflowX: "auto", borderRadius: 2, boxShadow: 2 }}>
                <Table sx={{ minWidth: 650}}>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "primary.main" }}>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", width: "25%", textAlign: "center"  }}>Número</TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", width: "25%", textAlign: "center"  }}>Nombre</TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", width: "25%", textAlign: "center"  }}>Max. Imp. Diario</TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold", width: "25%", textAlign: "center"  }}>Acciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {agencies.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={3} align="center" sx={{ color: "#888" }}>
                                    {message !== "" ? message : "No agencies available."}
                                </TableCell>
                            </TableRow>
                        ) : (
                            agencies.map((agency, idx) => (
                                <TableRow
                                    key={agency.id || idx}
                                    sx={{ borderBottom: "1px solid #f0f0f0" }}
                                >
                                    <TableCell sx={{ textAlign: "center" }}>
                                        {`${agency.puntoDeVenta}-${agency.maquina}`}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>
                                        {agency.name}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>
                                        {agency.maxImporteDiario?.toLocaleString("es-AR", {
                                            style: "currency",
                                            currency: "ARS",
                                            currencyDisplay: "symbol",
                                        })}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>
                                        <EditIcon
                                            /* className={styles.maximoButton} */
                                            onClick={() => handleEdit(agency)}
                                            sx={{ cursor: "pointer" }}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </Paper>
        </Grid>
    );
};

export default AgenciesTable;